'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');
var WeekdayControl = require('./components/WeekdayControl.js');

var WEEKDAYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
var ActiveWeekdayHours = function (props) {
    var activeWeekdayData = props.activeWeekdayData, onChange = props.onChange;
    var data = React.useRef(activeWeekdayData);
    var handleChange = function (day, attribute, newValue) {
        if (attribute === 'active') {
            data.current[day][attribute] = newValue;
        }
        else if (attribute === 'from' || attribute === 'to') {
            data.current[day][attribute] = newValue;
        }
        onChange(data.current);
    };
    return (React__default.createElement(styledComponents.StyledCard, null, WEEKDAYS.map(function (day) { return (React__default.createElement(styledComponents.WeekdayContainer, { key: day, "data-testid": "active-weekday-" + day },
        React__default.createElement(WeekdayControl, { day: day, dayData: data.current[day], onChange: handleChange }))); })));
};

module.exports = ActiveWeekdayHours;
